import { SelectInput } from "@/components/admin/select-input";
import { TextInput } from "@/components/admin/text-input";
import { DateTimeInput } from "@/components/admin";
import { required } from "ra-core";

import type { CampaignTargetDraft } from "../types";
import { CampaignTargetInput } from "./CampaignTargetInput";

const statusChoices = [
  { id: "draft", name: "Draft" },
  { id: "active", name: "Active" },
  { id: "completed", name: "Completed" },
];

export const CampaignInputs = ({
  targets,
  onTargetsChange,
}: {
  targets: CampaignTargetDraft[];
  onTargetsChange: (targets: CampaignTargetDraft[]) => void;
}) => (
  <div className="flex flex-col gap-4">
    <TextInput source="name" validate={required()} />
    <TextInput source="description" multiline />
    <TextInput source="product_name" label="Product name" />
    <SelectInput
      source="status"
      choices={statusChoices}
      validate={required()}
      defaultValue="draft"
    />
    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
      <DateTimeInput source="start_date" />
      <DateTimeInput source="end_date" />
    </div>
    <CampaignTargetInput targets={targets} onChange={onTargetsChange} />
  </div>
);
